import '@innovastudio/contentbuilder/public/assets/ionicons/css/ionicons.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '~/modules/contentbuilder/content.scss'
import '~/modules/contentbuilder/legacy.scss'

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const glideSlideshows = document.querySelectorAll('[data-module="slider-builder"], [data-module="text-slider"]')

    if(glideSlideshows.length) {
      import('@innovastudio/contentbuilder/public/assets/scripts/glide/glide.js').then((module) => {
        window.Glide = module.default
      })
      import('@innovastudio/contentbuilder/public/assets/scripts/glide/css/glide.core.css')
      import('@innovastudio/contentbuilder/public/assets/scripts/glide/css/glide.theme.css')
    }
  }
}
